import SearchFilterMini from './SearchFilterMini';

export default SearchFilterMini;
